export default __webpack_public_path__ + "static/media/Tanmay.88e0db41.jpeg";